import React from 'react'
import { Center, Image } from '@mantine/core'
import chat from '@src/assets/chat.png'
import {useLocation, useSearchParams} from "react-router-dom";
import {queryKeFuUrl} from "@src/api/orderService";

export default function ServiceChatWrapper({ children }: { children: React.ReactNode }) {
    let  url:string = 'https://work.weixin.qq.com/kfid/kfc43559d9104c8d2ba';

    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const hideServiceChat =
      location.pathname === '/face' || location.pathname === '/faceResult'
        || location.pathname === '/paymentReceipt' ;

    try{
        let linkId = searchParams.get("linkId");
        linkId =  linkId === null || linkId === undefined ? '' : linkId;
        let orderId  = location.pathname.split('/').pop();
        orderId =  orderId === null || orderId === undefined ? '' : orderId;
        queryKeFuUrl({linkId:linkId,orderId:orderId}).then((res) => {
            if(res.success && res.data !== ''){
                url = res.data.toString();
            }
        });
    }catch (e){
        console.log('获取客服链接出错，使用默认链接代替',e);
    }
  return (
    <>
      {children}
      {!hideServiceChat && (
        <Center
          className={'fixed right-[10px] bottom-[20px] z-[999]'}
          onClick={() => {
            window.open(url)
          }}
          w={60}
          h={60}
        >
          <Image src={chat} alt={'wechat'} />
        </Center>
      )}
    </>
  )
}
